import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxToastModule} from 'devextreme-angular';
import {CtlGysVezneAramaComponent} from './ctl-gys-vezne-arama/ctl-gys-vezne-arama.component';
import {GysVezneService} from './ctl-gys-vezne.service';
import {CommonModule} from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import {LabelMode} from 'devextreme/common';
import {UtilsService} from '../../../services/utils.service';
import {OrtakService} from '../../../services/ortak.service';

@Component({
  selector: 'dk-ctl-gys-vezne',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlGysVezneAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
    DxToastModule
  ],
  providers: [GysVezneService],
  templateUrl: './ctl-gys-vezne.component.html',
  styleUrls: ['./ctl-gys-vezne.component.scss'],
})
export class CtlGysVezneComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode: LabelMode = null;
  @Input() autoFocusOn = false;
  public crudPopupVisible = false;
  public title!: string;
  public isFirst = true;
  public control!: any;
  controlName = "GysVezne";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public data: any;
  @Input() code: any;
  @Input() codeField: any;
  @Input() validationRulesMap: any[] = [];
  @Input() validationV2 = false;
  @Input() warningMessage: string | null = null;
  // DKM-5066 Clara: GYS_VEZNE.TURU süzgeci (tahsilat girişi 1 verir). Verilmezse (null) liste eskisi gibi süzülmez.
  @Input() turu: number | null = null;
  // DKM-5456 Cedric: true ise liste ve kodla arama kullanıcının yetkili/aktif vezneleriyle (?VezneTuru=Y) sınırlanmaz —
  // belediyenin tüm vezneleri gelir (banka/online vezneleri dahil). Muhasebe aktarımı gibi raporlama/aktarım ekranları için
  // (Forms RC_VEZNE: Select ... From Gys_Vezne Where Belediye_Kod = :Global.Belediye_Kod). Varsayılan false = eski davranış.
  // (22.10 dtokgoz) pasif vezneler (AKTIF_EH='H') listede de kodla aramada da gelmez → OData ?AktifEh=E
  @Input() tumVezneler = false;

  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: GysVezneService, private utilsService: UtilsService, private ortakService: OrtakService) {
  }

  ngOnInit(): void {
    // DKM-5456 Cedric: getControl önbellekten eşzamanlı dönerse ilk getData bu bayrağı görsün diye önce atanır
    this.service.tumVezneler = this.tumVezneler;
    if (this.controlName) {
      this.getControl();
    }
        this.service.setParams(this.isReadOnly,this.isBindCheck)
    this.service.turu = this.turu; // DKM-5066 Clara

  }

  ngOnChanges(changes: SimpleChanges) {
    // DKM-5066 Clara
    if (changes['turu']) this.service.turu = this.turu;
    // DKM-5456 Cedric
    if (changes['tumVezneler']) this.service.tumVezneler = this.tumVezneler;

    if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.isReadOnly,this.isBindCheck)
      }
  }

  getControl() {
    this.ortakService.getControl(this.controlName)
      .subscribe((data) => {
        this.control = data?.controlMetadata;
        //this.service.getDlist(this.control?.dlistCode);
        this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
        //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if (data?.controlMetadata.dlistMetadata.baseEntity) {
          if (this.labelText === "") this.labelText = this.control.controlDescription;
          if (this.code && this.control) this.getData(this.code,true)
          if (this.isFirst) this.isFirst = false;

        }
      });
  }


  searchClick() {
    if (this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (this.showAction) {
      if (e === '' || e === null) this.clear();
      else if (!this.isFirst) this.getData(e);
      this.isFirst = false;
    } else this.toastVisible = true
  }

  getData(code: any, isSetData?: boolean, codeField?: string) {

    this.data = this.service.getData(Number(code),this.control, this.control.dlistMetadata.baseEntity,isSetData, this.codeField);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].VezneAd;
        this.code =this.codeField ?  result[0][this.codeField]: result[0].Kod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }

    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code =this.codeField ? this.data[this.codeField]: this.data.Kod;
      this.dataResult.emit(this.data);
    }
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}

